import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Table, message, notification, Icon, Tooltip, Spin } from "antd";

//Component import
import LocationPageBuilder from "../PageBuilder";
import Empty from "../../../components/Custom/Empty";

//Utility
import { sortFunction, sortFunction2 } from "../../../../utility/sorter";
import { COOKIE, getCookie } from "../../../../services/cookie";
import { fetchApi, fetchExcelApi } from "../../../../services/api";
import { cloneDeep, filter } from "lodash";
import { formatDate } from "../../../../utility/date";
import moment from "moment";
import DeathReasonList from "../deathReasonList";
// import { nullLiteral } from "@babel/types";

class Trees extends Component {
  componentRef = React.createRef();
  state = {
    addModal: false,
    data: [],
    dynamicTableData: [],
    btnLoad: false,
    pagination: true,

    blockNumber: null,
    blockNoList: [],
    block_uuid: null,

    areaNumber: null,
    areaNoList: [],
    area_uuid: null,

    rowNumber: null,
    rowNoList: [],
    row_uuid: null,

    treesNumber: null,
    treesNoList: [],
    trees_uuid: null,

    treeTypeCode: null,
    treeTypeCodeList: [],
    treeType_uuid: null,

    editData: null,
    isEdit: false,
    isDelete: false,
    addPopulateData: null,
    tableLoader: false,

    blockUuid: null,
    areaUuid: null,
    rowUuid: null,
    treeTypeUuid: null,
    treeUuid: null,
    treeNum: null,
    treeSuffix: null,
    showDeathReasonInput: false
  };

  componentDidMount() {
    this.setState({ tableLoader: true });
    this.fetchTrees();
    this.fetchBlockNo();
    this.fetchTreeTypeCode();
    const tableCon = ReactDOM.findDOMNode(this.refs["table"]),
      table = tableCon.querySelector("table"),
      header = table.createTHead(),
      row = header.insertRow(0);
    //cell = row.insertCell(0);
    row.innerHTML = `<h1>Tall Tree Master - List &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Farm
    : ${getCookie(COOKIE.FARM)}${" "} </h1>`;
    table.setAttribute("id", "table-to-xls");
    table.setAttribute("class", "Seedling-Plant-Tree");
  }

  fetchTrees = () => {
    this.setState({
      tableLoader: true,
      dynamicTableData: [],
      pagination: false
    });
    let { block_uuid, area_uuid, row_uuid } = this.state,
      url = "/talls?stageCode=3";
    if (block_uuid) url += `&block.uuid=${block_uuid}`;
    if (area_uuid) url += `&area.uuid=${area_uuid}`;
    if (row_uuid) url += `&row.uuid=${row_uuid}`;
    fetchApi(url, "get")
      .then(data =>
        this.setState(
          {
            tableLoader: false,
            data: data.map(({ dtPlanted, ...it }) => {
              return {
                dtPlanted: formatDate(dtPlanted),
                date: dtPlanted,
                ...it
              };
            })
          },
          () =>
            this.setState(
              {
                dynamicTableData: sortFunction2(this.state.data, [
                  "treeNoFull",
                  "rowNo",
                  "areaNo",
                  "blockNo"
                ]),
                pagination: true
              },
              () => this.tableFilterHandler()
            )
        )
      )
      .catch(err => {
        this.setState({ tableLoader: false });
        message.error("Internal Server Error");
      });
  };

  fetchBlockNo = () => {
    let { blockNumber } = this.state,
      url = "/blocksuuid";
    if (blockNumber) url += `?blockNo=${blockNumber}`;
    fetchApi(url, "get").then(data =>
      this.setState({ blockNoList: sortFunction(data, "blockNoFull") })
    );
  };

  fetchTreeTypeCode = () =>
    fetchApi(
      "/tree_types?type=2&properties[]=uuid&properties[]=code",
      "get"
    ).then(data => this.setState({ treeTypeCodeList: data }));

  addModalToggle = () => {
    let { addModal } = this.state;

    if (addModal) {
      this.setState({
        addModal: false,
        editData: null,
        isEdit: false,
        isDelete: false,
        showDeathReasonInput: false,
      });
    } else {
      this.setState({ addModal: !this.state.addModal });
    }
  };

  addFormHandler = ({
    treeNo,
    treeNoSuffix,
    treeType,
    dtPlanted,
    dtRemoved,
    reason,
    otherreason,
    tagNumber,
    ...val
  }) => {
    //to remove the previous instances of
    notification.destroy();

    let {
      treeType_uuid,
      isEdit,
      isDelete,
      blockUuid,
      areaUuid,
      rowUuid,
      treeTypeUuid,
      treeUuid,
      treeNum,
      treeSuffix
    } = this.state;
    this.setState({ btnLoad: true });
    if (isEdit) {
      fetchApi(`/talls/${treeUuid}`, "put", {
        treeNo: parseInt(treeNum),
        suffix: treeSuffix == "--All--" || treeSuffix == "" ? null : treeSuffix,
        dtPlanted: dtPlanted.format("YYYY-MM-DD"),
        treeType: `/tree_types/${treeType_uuid ? treeType_uuid : treeTypeUuid}`,
        tagNumber: tagNumber? tagNumber.toUpperCase(): "",
        stageCode: 3,
        growthCode: 1,
        block: "/blocks/" + blockUuid,
        area: "/areas/" + areaUuid,
        row: "/rows/" + rowUuid,
        ...val
      }).then(res => {
        if (res) {
          if (res.violations) {
            notification.error({
              message: "Failed",
              description: res.violations[0].message
            });
          } else {
            notification.success({
              message: "Success",
              description: "Successfully updated Tall Tree"
            });
            this.fetchTrees();
            this.addModalToggle()
          }
        } else {
          notification.error({
            message: "Failed",
            description: "Failed to update Tall Tree"
          });
        }
        this.setState(
          {
            btnLoad: false
          }
          //,
          //() => this.addModalToggle()
        );
      });
    } else if (isDelete) {
      fetchApi(`/talls/remove/${treeUuid}`, "post", {
        dtDied: dtRemoved.format("YYYY-MM-DD"),
        deleteReason: reason === "OR - Other Reason" ? "OR - " + otherreason : reason
      }).then(res => {
        if (res) {
          if (res.violations) {
            notification.error({
              message: "Failed",
              description: res.violations[0].message
            });
          } else {
            notification.success({
              message: "Success",
              description: "Successfully deleted Tall Tree"
            });
            this.setState({ showDeathReasonInput: false });
            this.fetchTrees();
            this.addModalToggle()
          }
        } else {
          notification.error({
            message: "Failed",
            description: "Failed to delete Tall Tree"
          });
        }
        this.setState(
          {
            btnLoad: false
          }
          //,
          // () => this.addModalToggle()
        );
      });
    }
  };

  onBlockChangeHandler = it => {
    let { blockNoList } = this.state;

    if (it) {
      fetchApi(
        `/areasuuid?block.uuid=${
        cloneDeep(blockNoList).filter(item => item.blockNoFull == it)[0].uuid
        }`,
        "get"
      ).then(res => this.setState({ areaNoList: res }));
    }

    this.setState(
      {
        blockNumber: it ? it : null,
        block_uuid: it
          ? cloneDeep(blockNoList).filter(item => item.blockNoFull == it)[0]
            .uuid
          : null,
        areaNumber: null,
        area_uuid: null,
        areaNoList: [],
        rowNumber: null,
        row_uuid: null,
        rowNoList: [],
        treesNumber: null,
        treesNoList: []
      },
      () => this.fetchTrees()
    );
  };

  onAreaChangeHandler = it => {
    let { areaNoList, blockNoList, blockNumber } = this.state;

    if (it) {
      fetchApi(
        `/rowsuuid?area.uuid=${
        cloneDeep(areaNoList).filter(item => item.areaNo == it)[0].uuid
        }&block.uuid=${
        cloneDeep(blockNoList).filter(
          item => item.blockNoFull == blockNumber
        )[0].uuid
        }`,
        "get"
      ).then(res =>
        this.setState({ rowNoList: sortFunction(res, "rowNoFull") })
      );
    }

    this.setState(
      {
        areaNumber: it ? it : null,
        area_uuid: it
          ? cloneDeep(areaNoList).filter(item => item.areaNo == it)[0].uuid
          : null,
        rowNumber: null,
        rowNoList: [],
        row_uuid: null,
        treesNumber: null,
        treesNoList: []
      },
      () => this.fetchTrees()
    );
  };

  onRowChangeHandler = it => {
    let {
      rowNoList,
      areaNoList,
      blockNoList,
      blockNumber,
      areaNumber
    } = this.state;

    if (it) {
      fetchApi(
        `/talls?stageCode=3&row.uuid=${
        cloneDeep(rowNoList).filter(item => item.rowNoFull == it)[0].uuid
        }&area.uuid=${
        cloneDeep(areaNoList).filter(item => item.areaNo == areaNumber)[0]
          .uuid
        }&block.uuid=${
        cloneDeep(blockNoList).filter(
          item => item.blockNoFull == blockNumber
        )[0].uuid
        }&properties[]=uuid&properties[]=treeNoFull`,
        "get"
      ).then(res =>
        this.setState({ treesNoList: sortFunction(res, "treeNoFull") })
      );
    }

    this.setState(
      {
        rowNumber: it ? it : null,
        row_uuid: it
          ? cloneDeep(rowNoList).filter(item => item.rowNoFull == it)[0].uuid
          : null,
        treesNumber: null,
        treesNoList: []
      },
      () => this.fetchTrees()
    );
  };

  onTreesChangeHandler = it => {
    let { treesNoList } = this.state;

    this.setState(
      {
        treesNumber: it ? it : null,
        trees_uuid: it
          ? cloneDeep(treesNoList).filter(item => item.treeNoFull == it)[0].uuid
          : null
      },
      () => this.fetchTrees()
    );
  };

  onTreeTypeChangeHandler = it => {
    let { treeTypeCodeList } = this.state;

    this.setState(
      {
        treeTypeCode: it ? it : null,
        treeType_uuid: it
          ? cloneDeep(treeTypeCodeList).filter(item => item.code == it)[0].uuid
          : null
      },
      () => this.tableFilterHandler()
    );
  };

  onDeathReasonChange = it => {
    if (it === "OR - Other Reason") {
      this.setState({ showDeathReasonInput: true });
    }
    else {
      this.setState({ showDeathReasonInput: false });
    }
  };

  tableFilterHandler = () => {
    let { blockNumber, areaNumber, rowNumber, treesNumber, data } = this.state,
      filterJson = {};
    if (blockNumber) filterJson.blockNo = blockNumber;
    if (areaNumber) filterJson.areaNo = areaNumber;
    if (rowNumber) filterJson.rowNo = rowNumber.toString();
    if (treesNumber) filterJson.treeNoFull = treesNumber;

    this.setState({
      dynamicTableData: filter(data, filterJson)
    });
  };

  onActionClickHandler = (item, action) => {
    let { treeTypeCodeList } = this.state;
    this.setState(
      {
        isEdit: action === "edit" ? true : false,
        isDelete: action === "delete" ? true : false
      },
      () => {
        this.setState({
          blockUuid: item.blockUuid,
          areaUuid: item.areaUuid,
          rowUuid: item.rowUuid,
          treeType_uuid: null,
          treeTypeUuid: cloneDeep(treeTypeCodeList).filter(
            it => it.code == item.treeType
          )[0].uuid,
          treeUuid: item.uuid,
          treeNum: item.treeNo,
          treeSuffix: item.suffix,
          addModal: true,
          editData: {
            blockNo: item.blockNo,
            areaNo: item.areaNo,
            rowNo: item.rowNo,
            treeNoFull: item.treeNoFull,
            treeType: item.treeType,
            tagNumber: item.tagNumber? item.tagNumber.toUpperCase(): "",
            dtPlanted: moment(item.date, "YYYY-MM-DD")
          }
        });
      }
    );
  };

  generateExcel = () => {
    let { block_uuid, area_uuid, row_uuid } = this.state,
      url = "/talls?stageCode=3";
    if (block_uuid) url += `&block.uuid=${block_uuid}`;
    if (area_uuid) url += `&area.uuid=${area_uuid}`;
    if (row_uuid) url += `&row.uuid=${row_uuid}`;
    fetchExcelApi(url, "get").then();
  };

  render() {
    let {
      addModal,
      dynamicTableData,
      btnLoad,
      blockNoList,
      blockNumber,
      areaNoList,
      areaNumber,
      rowNoList,
      rowNumber,
      treesNoList,
      treesNumber,
      treeTypeCodeList,
      editData,
      isEdit,
      isDelete,
      tableLoader,
      pagination,
      data,
      showDeathReasonInput
    } = this.state;
    const columns = [
      {
        title: "Tree No.",
        dataIndex: "treeNoFull"
      },
      {
        title: "Tag No.",
        dataIndex: "tagNumber",
        render: it => (it ? it.toUpperCase() : "-")
      },
      {
        title: "Tree Type",
        dataIndex: "treeType"
      },
      {
        title: "Block No.",
        dataIndex: "blockNo"
      },
      {
        title: "Area No.",
        dataIndex: "areaNo"
      },
      {
        title: "Row No.",
        dataIndex: "rowNo"
      },
      {
        title: "Date of Planting",
        dataIndex: "dtPlanted"
      },
      {
        title: "Action",
        className: "action",
        render: it => (
          <Fragment>
            <Tooltip placement="topRight" title={"Edit"}>
              <Icon
                type="edit"
                className="table-action-btn"
                onClick={() => this.onActionClickHandler(it, "edit")}
              />
            </Tooltip>
            <Tooltip placement="topRight" title={"Delete"}>
              <Icon
                type="delete"
                className="table-action-btn"
                onClick={() => this.onActionClickHandler(it, "delete")}
              />
            </Tooltip>
          </Fragment>
        )
      }
    ],
      formItems = [
        {
          name: "blockNo",
          placeholder: "Block No.",
          disabled: true
        },
        {
          name: "areaNo",
          placeholder: "Area No.",
          type: "number",
          disabled: true
        },
        {
          name: "rowNo",
          placeholder: "Row No.",
          disabled: true
        },
        {
          name: "treeNoFull",
          placeholder: "Tree No.",
          disabled: true
        }
      ];
    const _formItems = isEdit
      ? formItems.concat([
        {
          name: "treeType",
          placeholder: "Tree Type",
          listData: cloneDeep(treeTypeCodeList).map(it => it.code),
          changeHandler: it => this.onTreeTypeChangeHandler(it)
        },
        {
          name: "tagNumber",
          placeholder: "Tag No.",
          type: "tagNum",
        },
        {
          name: "dtPlanted",
          placeholder: "Date of Planting",
          type: "date",
          disabled: true
        }
      ])
      : isDelete
        ? formItems.concat([
          {
            name: "treeType",
            placeholder: "Tree Type",
            disabled: true
          },
          {
            name: "tagNumber",
            placeholder: "Tag No.",
            disabled: true,
            required: false
          },
          {
            name: "dtPlanted",
            placeholder: "Date of Planting",
            type: "date",
            disabled: true
          },
          {
            name: "dtRemoved",
            placeholder: "Date of Removal",
            type: getCookie(COOKIE.ROLE) === "ROLE_ADMIN"? "date": "date_yesterday",
          },
          {
            name: "reason",
            placeholder: "Reason for Deletion",
            listData: DeathReasonList.deathReasonList,
            changeHandler: it => this.onDeathReasonChange(it),
            required: true,
          },
          {
            name: "otherreason",
            placeholder: "Other Reason for Deletion",
            required: showDeathReasonInput,
            type: showDeathReasonInput ? "text" : "hidden"
          }
        ])
        : null;
    const buttonList =
      data.length > 0
        ? [
          {
            label: "Excel",
            icon: "file-text",
            onClickHandler: () => this.generateExcel()
          },
          {
            label: "Print",
            icon: "diff",
            reference: this.componentRef
          },
          {
            label: this.state.pagination ? "View All" : "View Less",
            icon: "container",
            onClickHandler: () => this.setState({ pagination: !pagination })
          }
        ]
        : null;
    return (
      <LocationPageBuilder
        title="Tall Tree Master"
        buttonList={buttonList}
        dropDownList={[
          {
            label: "Block",
            listItems: cloneDeep(blockNoList).map(it => it.blockNoFull),
            value: blockNumber ? blockNumber : undefined,
            changeHandler: it => this.onBlockChangeHandler(it)
          },
          {
            label: "Area",
            listItems: cloneDeep(areaNoList).map(it => it.areaNo),
            disabled: blockNumber ? false : true,
            value: areaNumber ? areaNumber : undefined,
            changeHandler: it => this.onAreaChangeHandler(it)
          },
          {
            label: "Row",
            listItems: cloneDeep(rowNoList).map(it => it.rowNoFull),
            disabled: areaNumber ? false : true,
            value: rowNumber ? rowNumber : undefined,
            changeHandler: it => this.onRowChangeHandler(it)
          },
          {
            label: "Tree No.",
            listItems: cloneDeep(treesNoList).map(it => it.treeNoFull),
            disabled: rowNumber ? false : true,
            value: treesNumber ? treesNumber : undefined,
            changeHandler: it => this.onTreesChangeHandler(it)
          }
        ]}
        addModal={addModal}
        addModalToggle={this.addModalToggle}
        addFormHandler={this.addFormHandler}
        editData={editData ? editData : null}
        btnLoad={btnLoad}
        formItems={_formItems}
        isEdit={isEdit}
        isDelete={isDelete}
      >
        <div ref={this.componentRef}>
          {/* <h1>
            Tall Tree Master - List &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Farm :{" "}
            {getCookie(COOKIE.FARM)}{" "}
          </h1> */}
          <Spin spinning={tableLoader} size="large">
            <Table
              ref="table"
              columns={columns}
              dataSource={dynamicTableData}
              pagination={!pagination ? pagination : { pageSize: 15 }}
            //loading={tableLoader}
            locale={{
              emptyText: <Empty />
            }}
            />
          </Spin>
        </div>
      </LocationPageBuilder>
    );
  }
}

export default Trees;
